<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">Disable user?</h2>
  <p class="dialog-subtitle">
    "{{ data.userEmail }}" will immediately lose access and be logged out. The reason is shown to
    them the next time they try to sign in, so write it for them.
  </p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Reason</mat-label>
    <textarea matInput [(ngModel)]="reason" name="reason" rows="3" placeholder="Suspicious activity reported"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button
    mat-flat-button
    class="btn-submit btn-submit--danger"
    (click)="submit()"
    [disabled]="isSubmitting() || !reason.trim()"
  >
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Disabling…' : 'Disable' }}
  </button>
</mat-dialog-actions>
